import React, { FC } from 'react';
import styled from 'styled-components';
import theme from '~/theme';

interface AccountNumberProps {
  accountNumber: string;
  phoneNumber?: string;
}

const AccountNumber: FC<AccountNumberProps> = (props) => {
  const { accountNumber, phoneNumber } = props;
  return (
    <>
      {phoneNumber && (
        <>
          <PhoneNumber>{phoneNumber}</PhoneNumber>
          <span>{` →`}</span>
        </>
      )}
      <div>{accountNumber}</div>
    </>
  );
};

const PhoneNumber = styled.span`
  color: ${theme.textColorGray};
`;

export default AccountNumber;
